var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualityFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.503 11.9999V6.99917C18.503 6.93602 18.4906 6.87348 18.4665 6.81514C18.4423 6.7568 18.4069 6.7038 18.3622 6.65917L15.8438 4.1408C15.7539 4.05076 15.6319 4.00011 15.5046 4H6.18312C6.05582 4 5.93373 4.05057 5.84371 4.14059C5.7537 4.2306 5.70312 4.35269 5.70312 4.47999V19.5198C5.70312 19.6471 5.7537 19.7692 5.84371 19.8592C5.93373 19.9493 6.05582 19.9998 6.18312 19.9998H11.3031M8.90309 10.3999H15.303M8.90309 7.19997H12.1031M8.90309 13.5999H11.3031",
    stroke: "#EE3224",
    strokeWidth: 1.19999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3031 4V6.71997C15.3031 6.84727 15.3537 6.96936 15.4437 7.05938C15.5337 7.14939 15.6558 7.19997 15.7831 7.19997H18.5031M15.5479 16.0903L16.2751 14.5487C16.2948 14.5046 16.3268 14.4672 16.3672 14.4409C16.4077 14.4146 16.4549 14.4007 16.5031 14.4007C16.5514 14.4007 16.5986 14.4146 16.6391 14.4409C16.6795 14.4672 16.7115 14.5046 16.7311 14.5487L17.4591 16.0903L19.0847 16.3391C19.2935 16.3711 19.3767 16.6399 19.2263 16.7935L18.0495 17.9935L18.3271 19.6878C18.3623 19.9054 18.1439 20.0718 17.9575 19.9686L16.5031 19.1686L15.0487 19.9686C14.8616 20.0718 14.644 19.9054 14.6792 19.6878L14.9568 17.9935L13.7808 16.7935C13.6288 16.6399 13.7128 16.3711 13.9216 16.3391L15.5479 16.0903Z",
    stroke: "#EE3224",
    strokeWidth: 1.19999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityFilter);
export default __webpack_public_path__ + "static/media/QualityFilter.2aa44da74c53a3d44704dd62ef2c1df9.svg";
export { ForwardRef as ReactComponent };